// import * as React from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import {
	Table,
	TableBody,
	// 	TableCaption,
	TableCell,
	// 	TableFooter,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { ArrowLeft, FileUp } from "lucide-react";
import {
	Card,
	CardHeader,
	CardTitle,
	CardDescription,
	CardContent,
} from "@/components/ui/card";

import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";

const DataTest = [
	{
		id: 1,
		title: "ໜີ້ສິນໝູນວຽນ",
		Sumtitles: "ລວມຍອດ ໜີ້ສິນໝູນວຽນ ( I )",
		sumthisyear: "257.789,80",
		sumlastyear: "29.000,00",
		Details: [
			{
				subtitle: "ລາຍຮັບຈາກກິດຈະການປົກກະຕິ",
				thisyear: "1,000,000",
				lastyear: "1,000,000",
				Note: "1,000,000",
			},
			{
				subtitle: "ຕົ້ນທຶນຂາຍ",
				thisyear: "192.350,00",
				lastyear: "17.000,00",
				Note: "1,000,000",
			},
		],
	},
	{
		id: 2,
		title: "ໜີ້ສິນບໍ່ໝູນວຽນ",
		Sumtitles: "ຜົນໄດ້ຮັບ ເບື້ອງຕົ້ນ",
		sumthisyear: "257.789,80",
		sumlastyear: "29.000,00",
		Details: [
			{
				subtitle: "ລາຍຮັບອື່ນໆ ຈາກການດໍາເນີນງານປົກກະຕິ",
				thisyear: "1,000,000",
				lastyear: "1,000,000",
				Note: "1,000,000",
			},
			{
				subtitle: "ຕົ້ນທຶນຈາກການຈໍາໜ່າຍ",
				thisyear: "192.350,00",
				lastyear: "17.000,00",
				Note: "1,000,000",
			},
			{
				subtitle: "ຕົ້ນທຶນບໍລິຫານ",
				thisyear: "192.350,00",
				lastyear: "17.000,00",
				Note: "1,000,000",
			},
			{
				subtitle: "ຄ່າໃຊ້ຈ່າຍອື່ນໆ ໃນທຸລະກິດ",
				thisyear: "42.339,80",
				lastyear: "1.500,00",
				Note: "1,000,000",
			},
		],
	},
	{
		id: 3,
		title: "ທຶນຕົນເອງ",
		Sumtitles: "ຜົນໄດ້ຮັບ ກ່ອນການເສຍອາກອນ",
		sumthisyear: "257.789,80",
		sumlastyear: "29.000,00",
		Details: [
			{
				subtitle: "ລາຍຮັບການເງິນ",
				thisyear: "192.350,00",
				lastyear: "17.000,00",
				Note: "1,000,000",
			},
			{
				subtitle: "ລາຍຈ່າຍການເງິນ",
				thisyear: "192.350,00",
				lastyear: "17.000,00",
				Note: "1,000,000",
			},
			{
				subtitle: "ໜີ້ສິນການເງິນ, ເງິນກູ້ຢືມ ໄລຍະສັ້ນ",
				thisyear: "1,000,000",
				lastyear: "1,000,000",
				Note: "1,000,000",
			},
			{
				subtitle: "ໜີ້ຕ້ອງສົ່ງລັດ (ຄ່າພາສີ-ອາກອນ)",
				thisyear: "42.339,80",
				lastyear: "1.500,00",
				Note: "10",
			},
			{
				subtitle: "ພັນທະໄລຍະສັ້ນ ຜົນປະໂຫຍດຂອງພະນັກງານ",
				thisyear: "23.100,00",
				lastyear: "10.500,00",
				Note: "11",
			},
			{
				subtitle: " ໜີ້ຕ້ອງສົ່ງ ໝູນວຽນອື່ນໆ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
			{
				subtitle: " ເງິນແຮ-ໜີ້ສິນໝູນວຽນ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
		],
	},
];
export const Route = createFileRoute(
	"/_layout-private/report/finance/bank/_layout/result/edit",
)({
	component: RouteComponent,
});

function RouteComponent() {
	const navigate = useNavigate();

	return (
		<section>
			<Card className="border-none">
				<CardHeader className="border-b mb-[32px]">
					<button
						type="button"
						onClick={() =>
							navigate({
								to: "/report/finance/bank/result",

							})
						}
						className="flex items-center gap-[4px]  mb-4"
					>
						<ArrowLeft className="w-5 h-5" />
						ກັບຄືນ
					</button>

					<CardTitle>ລາຍລະອຽດເອກະສານທາງການເງິນງວດປີ 2023</CardTitle>
					<CardDescription>ລາຍລະອຽດ</CardDescription>
				</CardHeader>
				<CardContent>
					<div className="flex items-center gap-x-1">
						<Label htmlFor="">ຫົວໜ່ວຍເງິນ</Label>
						<Select onValueChange={(value) => console.log(value)}>
							<SelectTrigger className="w-[150px] indent-1 font-bold border-none underline text-blue-500	">
								<SelectValue placeholder="ເລືອກການສະແດງ" />
							</SelectTrigger>
							<SelectContent>
								<SelectItem value="kip">ກີບ</SelectItem>
								<SelectItem value="baht">ບາດ</SelectItem>
							</SelectContent>
						</Select>
					</div>

					<div>
						<Table className="mb-4 ">
							<TableHeader>
								<TableRow>
									<TableHead className="w-auto border">ໜີ້ສິນ ແລະ ທຶນ</TableHead>
									<TableHead className="w-auto border">
										ມູນຄ່າຍັງເຫຼືອ(ປີນີ້)2023
									</TableHead>
									<TableHead className="w-auto border">
										ມູນຄ່າຍັງເຫຼືອ(ປີຜ່ານມາ) 2022
									</TableHead>
									<TableHead className="w-auto border">ໝາຍເຫດ</TableHead>
								</TableRow>
							</TableHeader>
							<TableBody>
								{DataTest.map((invoice, index) => (
									<>
										<TableRow key={index} className="font-bold bg-gray-100">
											<TableCell className="border">
												{invoice.Sumtitles}
											</TableCell>
											<TableCell className="border">
												{invoice.sumthisyear}
											</TableCell>
											<TableCell className="border">
												{invoice.sumlastyear}
											</TableCell>
											<TableCell className="border">{"-"}</TableCell>
										</TableRow>
										{invoice.Details.map((invoices, index) => (
											<TableRow key={index} className="cursor-pointer">
												<TableCell className="border">
													{invoices.subtitle}
												</TableCell>
												<TableCell className="border">
													<Input
														value={invoices.thisyear}
														placeholder="ປ້ອນ..."
													/>
												</TableCell>
												<TableCell className="border">
													<Input
														value={invoices.lastyear}
														placeholder="ປ້ອນ..."
													/>
												</TableCell>
												<TableCell className="border">
													<Input value={invoices.Note} placeholder="ປ້ອນ..." />
												</TableCell>
											</TableRow>
										))}
									</>
								))}
								<TableRow className="font-bold bg-gray-100 ">
									<TableCell className="py-8 border">
										ລວມຍອດລາຍຮັບ - ລາຍຈ່າຍ
									</TableCell>
									<TableCell className="border">1,000,000</TableCell>
									<TableCell className="border">1,000,000</TableCell>
									<TableCell className="border">{"-"}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</div>
					<div className="flex items-center justify-between h-24 mb-4 w--full">
						<div className="flex flex-col justify-center w-2/12 h-24 mb-4 ">
							<p>
								ເອກະສານຕິດຄັດ <span className="text-red-500">*</span>{" "}
							</p>
							<Button
								variant="outline"
								className="flex items-center gap-2 text-blue-500 border-blue-500"
							>
								<FileUp />
								ເອກະສານຕິຂັດ
							</Button>
						</div>
						<div className="flex gap-4">
							<Button
								className="flex items-center gap-2 bg-red-500"
								type="button"
							>
								<span>ຍົກເລີກ</span>
							</Button>
							<Button className="flex items-center gap-2" type="submit">
								<span>ບັນທຶກ</span>
							</Button>
						</div>
					</div>
					<div className="flex items-center justify-between w-full mt-12">
						<p>ທັງໝົດ 56 ລາຍການ </p>
						<div className="flex items-center space-x-2">
							<p>ໜ້າ 1 of 10</p>
							<div className="flex space-x-2">
								<button type="button" className="p-2 border rounded-md">
									&lt;&lt;
								</button>
								<button type="button" className="p-2 border rounded-md">
									&lt;
								</button>
								<button type="button" className="p-2 border rounded-md">
									&gt;
								</button>
								<button type="button" className="p-2 border rounded-md">
									&gt;&gt;
								</button>
							</div>
						</div>
					</div>
				</CardContent>
			</Card>
		</section>
	);
}
